export default __webpack_public_path__ + "static/media/dice_active.f4ebd390.svg";